var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "unauthorized-container" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center", "align-center": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "elevation-12 pa-8 text-center",
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mb-4",
                          attrs: { size: "100", color: "error" },
                        },
                        [_vm._v("mdi-lock-alert")]
                      ),
                      _c(
                        "h1",
                        { staticClass: "text-h4 font-weight-bold mb-4" },
                        [_vm._v(_vm._s(_vm.$t("Common.Unauthorized.Title")))]
                      ),
                      _c("p", { staticClass: "text-body-1 mb-6" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Common.Unauthorized.Message")) +
                            " "
                        ),
                      ]),
                      _c("v-divider", { staticClass: "mb-6" }),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column align-center" },
                        [
                          _c(
                            "base-btn",
                            {
                              staticClass: "mb-3",
                              attrs: { color: "primary", large: "" },
                              on: { click: _vm.goToHome },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-home"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Common.Unauthorized.GoHome")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                          _c(
                            "base-btn",
                            {
                              attrs: {
                                outlined: "",
                                color: "secondary",
                                large: "",
                              },
                              on: { click: _vm.goBack },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-arrow-left"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Common.Unauthorized.GoBack")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }